import classes from "./ReportFeedback.module.css";
import { FaBookmark } from "react-icons/fa6";
import {
  getActiveBranchIds,
  getActiveBranchIds1,
  getBranchInfobyId,
} from "../../util/multipleBranch/getActiveBranchId";
export default function ReportFeedback({ data }) {
  console.log(data);
  let currentFeedbackBranch = data?.admin_id;
  // console.log(data.bookMarked);
  const activeBranches = getActiveBranchIds1();
  let branches = JSON.parse(localStorage.getItem("branches"));
  const activeBranchNames = activeBranches.map((id) => {
    return getBranchInfobyId(id);
  });

  let date = new Date(data?.createdAt);
  let d1 = date.toLocaleDateString("en-IN");
  let d2 = d1.split("/").reverse().join("/");

  if (data == undefined) return null;
  return (
    <>
      <div className={classes.container}>
        <div className={classes.toplineInfo}>
          {branches.length > 1 && (
            <p>{getBranchInfobyId(data.admin_id).name}</p>
          )}
          <div
            className={`${
              data.bookMarked ? classes.savedBookmark : classes.bookmark
            }`}
          >
            <FaBookmark />
          </div>

          <p>Rating : {data?.rating}</p>
          <div className={classes.date}>
            <p>{d1}</p>
          </div>
        </div>
        <div>
          <div className={`${classes.innerContainer}`}>
            <div className={classes.bioDetails}>
              {data?.data.bioDetails.map((item, index) => {
                return (
                  <div className={classes.optionQuestion} key={`is ${index}`}>
                    <p>
                      <span>{index + 1} .</span>
                      {item.title}
                    </p>
                    <p
                      className={`${classes.optionResponse} ${classes.optionResponse1} `}
                    >
                      {item.answer}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>

          <div className={`  ${classes.innerContainer}`}>
            {data?.data.optionQuestions.map((item, index) => {
              let foodIssueStr = "";
              if (
                item.title != "foodIssue" &&
                item.title != "foodNameHavingIssue"
              ) {
                if (
                  item.title.includes("Food") ||
                  item.title.includes("food")
                ) {
                  let foodIssue = data.data.optionQuestions[0].answer;
                  let foodNameHavingIssue = data.data.optionQuestions[1].answer;
                  foodIssueStr = `${foodNameHavingIssue} :- ${foodIssue}`;

                  return (
                    <div className={classes.optionQuestion} key={`is ${index}`}>
                      <p>
                        <span>{index - 1} .</span>
                        {item.title}
                      </p>
                      <p
                        className={`${classes.optionResponse} ${classes.optionResponse1} `}
                      >
                        {item.answer}
                      </p>
                      {foodIssueStr.length > 5 && (
                        <div className={classes.foodIssueContainer}>
                          {" "}
                          <p className={classes.foodIssue}>
                            {foodIssueStr}
                          </p>{" "}
                        </div>
                      )}
                    </div>
                  );
                } else {
                  return (
                    <div className={classes.optionQuestion} key={`is ${index}`}>
                      <p>
                        <span>{index - 1} .</span>
                        {item.title}
                      </p>
                      <p
                        className={`${classes.optionResponse} ${classes.optionResponse1} `}
                      >
                        {item.answer}
                      </p>
                    </div>
                  );
                }
              }
            })}
          </div>
          <div className={classes.checkQuestions}>
            {/* {data?.data.checkQuestions && <h4>Check mark Questions</h4>} */}
            {data?.data.checkQuestions.map((item, index) => {
              return (
                <div key={`iss ${index}`}>
                  <p>
                    <span>{index + 1} .</span>
                    {item.title}
                  </p>
                  <p>
                    <span>Response : </span>
                    {item.answer}
                  </p>
                  <hr />
                </div>
              );
            })}
          </div>
        </div>
        <div className={`${classes.innerContainer}`}>
          <div className={classes.simpleQuestions}>
            {data?.data.simpleQuestions.map((item, index) => {
              return (
                <div className={classes.optionQuestion} key={`is ${index}`}>
                  <p>{item.title} </p> <br></br>
                  <div className={classes.simpleQuestionsResponse}>
                    <p>{item.answer}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}
